
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { LoginServices } from '@/services/LoginServices';
import { StorageServices } from '@/services/StorageServices';
import { LoginClient } from '@/services/Services';
import router from '@/router';
import store from '@/store';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class fplogo extends Vue {

    @Prop({
        default: false
    }) small: boolean;

    mounted() {
        if(this.small){
            let textEl = this.$refs.logoText as SVGTextElement;
            textEl.remove();
            return;
        }

        let svgEl = this.$refs.logoSvg as SVGElement;
        let shimmerEl = this.$refs.shimmer as HTMLElement;
        let data = new XMLSerializer().serializeToString(svgEl);
        let url = 'url("data:image/svg+xml;utf8,' + encodeURIComponent(data) + '")';
        shimmerEl.style.setProperty('--logo-mask', url);
    }

}
